import { useState, useEffect } from "react";
import api from "../../../services/api";
import getCommercial from "../../../util/getCommercial";
import { Main, Content } from "../../../components/Layout";
import { Col, Row, Form } from "react-bootstrap";
import tableStyle from "../../../components/Table/Table.module.css";
import IcX from "../../../components/Svg/IcX";
import styleButton from "../../../components/Button/Button.module.css";
import { ModalPayment, ModalConfirmPayment } from "../../../components/Modal";
import DatePicker from "../../../components/DatePicker";
import Slct from "../../../components/Slct";
import { Currency, IntegerNumber } from "../../../components/Input";
import Pagenation from "../../../components/Pagenation";
import Loading from "../../../components/Loading";
import TabNotification from "../../../components/TabNotification";
import { ModalConfirm, ModalReceipt } from "../../../components/Modal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import useWrapper from "../../../hooks/useWrapper";
import StatusFlag from "../../../components/StatusFlag";
import Dropdown2 from "../../../components/Dropdown";
import TableResponsive from "../../../components/TableResponsive";
import useFormat from "../../../hooks/utils/useFormat";

export default function BillsToPay() {
  const navigate = useNavigate();
  const { formatReal, formatDate } = useFormat();
  const { setbreadcrumb, me, config } = useWrapper();
  const permissions = JSON.parse(me.permissions);
  const [reload, setReload] = useState(false);
  const filter_start = {
    date_start: null,
    date_end: null,
    due_date: formatDate(new Date(), 3),
    id: "",
    value: null,
    type_payment: null,
    cost_center: null,
    expense_plan: null,
    expense: null,
    commercial: null,
    provider: null,
  };
  const [page, setPage] = useState({
    total: null,
    current: null,
  });
  const pageChange = p => {
    setPage({
      ...page,
      current: p,
    });
  };
  const [loadingPage, setLoadingPage] = useState(true);
  const [filterLoading, setFilterLoading] = useState(false);

  const [modalPayment, setmodalPayment] = useState(null);

  const [filterInputs, setfilterInputs] = useState();
  const [filter, setfilter] = useState(filter_start);

  const [bills, setbills] = useState([]);
  useEffect(() => {
    setFilterLoading(true);
    if (filter) {
      const PARAMS = new URLSearchParams({
        id: filter.id || "",
        value: filter.value || "",
        type_payment: filter.type_payment || "",
        cost_center_id: filter.cost_center || "",
        expense_plan_id: filter.expense_plan || "",
        expense_id: filter.expense || "",
        commercial_id: filter.commercial || "",
        provider_id: filter.provider || "",
        dueInterval:
          filter.date_start && filter.date_end
            ? `${formatDate(filter.date_start, 3)}|${formatDate(filter.date_end, 3)}`
            : "",
        ...("paid" in filter && { paid: filter.paid }),
        ...(!!filter.payment_for ? { payment_for: filter.payment_for } : {}),
        ...(filter?.due_date ? { due_date: formatDate(filter.due_date, 3) } : {}),
      });

      api
        .get(`bills-to-pay?page=${page.current}&${PARAMS.toString()}`, config)
        .then(response => {
          if (page.total !== response.data.lastPage) {
            setPage({
              ...page,
              total: response.data.lastPage || 1,
            });
          }
          if (page.current) {
            setbills(response.data.data);
          }
        })
        .then(() => {
          if (page.current) {
            setFilterLoading(false);
          }
          setLoadingPage(false);
        })
        .catch(error => {
          error.response.status === 401 && navigate("/no-permission");
        });
    }
  }, [reload]);

  useEffect(() => {
    if (JSON.stringify(filter_start) !== JSON.stringify(filter)) {
      setReload(!reload);
    }
  }, [filter]);
  useEffect(() => {
    if (page.current) {
      setReload(!reload);
    }
  }, [page.current]);

  const [commercials, setcommercials] = useState([]);
  const [providers, setproviders] = useState([]);
  const [methods, setmethods] = useState([]);
  const [costCenter, setcostCenter] = useState([]);

  useEffect(() => {
    if (permissions.commercial.reading) {
      getCommercial().then(response => {
        setcommercials(
          response.map(__commercial => ({
            ...__commercial,
            label: `${__commercial.label} ${
              __commercial.contract_number_legacy ? `(${__commercial.contract_number_legacy})` : ""
            }`,
          })),
        );
      });
    }
    api.get("cost-center", config).then(response => {
      setcostCenter(
        response.data
          .filter(e => e.type === "despesa")
          .map(e => ({
            label: e.name,
            value: e.id,
            expense_plans: e.expensePlan.map(e2 => ({
              label: e2.name,
              value: e2.id,
              expenses: e2.expenses.map(e3 => ({
                label: e3.name,
                value: e3.id,
              })),
            })),
          })),
      );
    });
    if (permissions.suppliers.reading) {
      api.get("providers", config).then(response => {
        setproviders(
          response.data.map(e => ({
            value: e.id,
            label: e.name,
          })),
        );
      });
    }
    setmethods([
      { label: "Dinheiro", value: "Dinheiro" },
      { label: "Cartão", value: "Cartão" },
      { label: "Boleto", value: "Boleto" },
      { label: "Transferência ou PIX", value: "Transferência ou PIX" },
    ]);
  }, []);

  const [filterTab, setfilterTab] = useState();
  const [paymentModal, setpaymentModal] = useState(null);
  const confirmPayment = () => {
    let _values = {
      paid: 1,
      paid_user_id: me.id,
      date_paid: new Date(),
    };
    api.put(`bills-to-pay/${paymentModal?.id}`, _values, config).then(() => {
      toast.success("Pagamento confirmado com sucesso!");
      setpaymentModal(null);
      setReload(!reload);
    });
  };

  useEffect(() => {
    setbreadcrumb([{ label: "Contas a Pagar" }]);
  }, []);

  const [receiveType, setreceiveType] = useState();
  const [editPayment, seteditPayment] = useState();

  const [paymentConfirm, setpaymentConfirm] = useState();

  const [cancelPaymentModal, setcancelPaymentModal] = useState();
  const cancelPayment = async () => {
    await api.put(
      `bills-to-pay/${cancelPaymentModal}`,
      {
        paid: -1,
      },
      config,
    );
    setReload(!reload);
    setcancelPaymentModal(null);
    toast.success("Pagamento cancelado com sucesso!");
  };

  return (
    <>
      <ModalConfirmPayment
        show={!!paymentConfirm}
        payment_id={paymentConfirm}
        closeModal={() => {
          setpaymentConfirm(null);
        }}
        reload={reload}
        setReload={setReload}
      />
      <ModalConfirm
        show={paymentModal}
        title="Confirmar Pagamento"
        text="Tem certeza que confirmar o pagamento?"
        confirm={confirmPayment}
        closeModal={() => {
          setpaymentModal(null);
        }}
        colorScheme="primary"
      />
      <ModalConfirm
        show={!!cancelPaymentModal}
        title="Cancelar Pagamento"
        text="Tem certeza que cancelar o pagamento?"
        confirm={cancelPayment}
        closeModal={() => {
          setcancelPaymentModal(null);
        }}
        colorScheme="error"
      />
      <ModalPayment
        commercials={commercials}
        providers={providers}
        methods={methods}
        costCenter={costCenter}
        payment={modalPayment}
        setPayment={setmodalPayment}
        closeModal={() => setmodalPayment(null)}
        reload={reload}
        setReload={setReload}
      />
      <ModalReceipt
        show={receiveType === "payment"}
        isPayment={true}
        onHide={() => {
          setreceiveType();
        }}
        reload={reload}
        setReload={setReload}
      />
      <ModalReceipt
        show={!!editPayment}
        isPayment={true}
        preLoad={{
          selects: {
            id: editPayment?.id,
            payment_for: !editPayment?.payment_for ? null : "turma",
            cost_center: editPayment?.cost_center_id,
            expense_plan: editPayment?.expense_plan_id,
            expense: editPayment?.expense_id,
            description: editPayment?.description,
            commercial_id: editPayment?.commercial_id,
            provider_id: editPayment?.provider_id,
          },
          values: {
            cost: editPayment?.value_raw,
            due_date: !!editPayment?.due_date ? new Date(editPayment?.due_date) : new Date(),
          },
        }}
        onHide={() => {
          seteditPayment();
        }}
        reload={reload}
        setReload={setReload}
      />
      <Main>
        {!loadingPage ? (
          <Content>
            <Row>
              <Col>
                <div className="d-flex justify-content-between mb-4">
                  <h2 className="page-title">Gerenciar Pagamentos</h2>
                  <div className="d-flex ml-4">
                    {permissions.financialCompany.create && (
                      <button
                        type="button"
                        className={`${styleButton.button_primary} ml-3`}
                        onClick={() => {
                          setreceiveType("payment");
                          // setmodalPayment({
                          //   cost_center_id: null,
                          //   expense_plan_id: null,
                          //   expense_id: null,
                          //   due_date: new Date(),
                          //   value: null,
                          //   type_payment: "",
                          //   provider_id: null,
                          //   commercial_id: null
                          // })
                        }}
                      >
                        <span>Registrar Pagamento</span>
                      </button>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              {permissions.commercial.reading && (
                <Col sm={2}>
                  <Form.Group>
                    <span className="lince-input_label">Referente à</span>
                    <Slct
                      placeholder="..."
                      value={filter.payment_for}
                      options={[
                        { value: null, label: "-- Todos --" },
                        { value: "empresa", label: "Empresa" },
                        ...(permissions.commercial.reading ? [{ value: "turma", label: "Turma" }] : []),
                      ]}
                      onChange={ev => {
                        setfilter({
                          ...filter,
                          init: false,
                          payment_for: ev.value,
                        });
                      }}
                    />
                  </Form.Group>
                </Col>
              )}
              <Col sm={2}>
                <Form.Group>
                  <span className="lince-input_label">Vencimento Inicial</span>
                  <DatePicker
                    selected={filter.date_start}
                    onChange={e => {
                      setfilter({
                        ...filter,
                        date_start: e,
                        ...(!filter.date_end ? { date_end: e } : {}),
                      });
                    }}
                  />
                </Form.Group>
              </Col>
              <Col sm={2}>
                <Form.Group>
                  <span className="lince-input_label">Vencimento Final</span>
                  <DatePicker
                    selected={filter.date_end}
                    onChange={e => {
                      setfilter({
                        ...filter,
                        date_end: e,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
              <Col sm={2}>
                <Form.Group>
                  <span className="lince-input_label">Código</span>
                  <IntegerNumber
                    value={filterInputs?.id || ""}
                    valueChange={ev => {
                      setfilterInputs({
                        ...filterInputs,
                        id: ev,
                      });
                    }}
                    onBlur={() => {
                      if ((filterInputs?.id || 0) !== (filter.id || 0)) {
                        setfilter({
                          ...filter,
                          id: filterInputs?.id,
                          init: false,
                        });
                      }
                    }}
                    maxlength="10"
                  />
                </Form.Group>
              </Col>
              <Col sm={2}>
                <Form.Group>
                  <span className="lince-input_label">Valor</span>
                  <Currency
                    value={filterInputs?.value || ""}
                    valueChange={ev => {
                      setfilterInputs({
                        ...filter,
                        value: ev || "",
                      });
                    }}
                    onBlur={() => {
                      if ((filterInputs?.value || 0) !== (filter.value || 0)) {
                        setfilter({
                          ...filter,
                          value: filterInputs?.value,
                          init: false,
                        });
                      }
                    }}
                  />
                </Form.Group>
              </Col>
              <Col sm={2}>
                <Form.Group>
                  <span className="lince-input_label">Método</span>
                  <Slct
                    placeholder="..."
                    value={filter.type_payment}
                    options={[{ label: "-- Todos --", value: "" }].concat(methods)}
                    onChange={ev => {
                      setfilter({
                        ...filter,
                        init: false,
                        type_payment: ev.value,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col sm={4}>
                <Form.Group>
                  <span className="lince-input_label">Centro de Custo</span>
                  <Slct
                    placeholder="..."
                    value={filter.cost_center}
                    options={[{ label: "-- Todos --", value: "" }].concat(costCenter)}
                    onChange={ev => {
                      setfilter({
                        ...filter,
                        init: false,
                        cost_center: ev.value,
                        expense_plan: null,
                        expense: null,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
              <Col sm={4}>
                <Form.Group>
                  <span className="lince-input_label">Plano de Conta</span>
                  <Slct
                    placeholder="..."
                    value={filter.expense_plan}
                    options={
                      filter.cost_center
                        ? [{ label: "-- Todos --", value: "" }].concat(
                            costCenter.find(e => e.value === filter.cost_center).expense_plans,
                          )
                        : []
                    }
                    onChange={ev => {
                      setfilter({
                        ...filter,
                        init: false,
                        expense_plan: ev.value,
                        expense: null,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
              <Col sm={4}>
                <Form.Group>
                  <span className="lince-input_label">Conta</span>
                  <Slct
                    placeholder="..."
                    value={filter.expense}
                    options={
                      filter.cost_center && filter.expense_plan
                        ? [{ label: "-- Todas --", value: "" }].concat(
                            costCenter
                              .find(e => e.value === filter.cost_center)
                              .expense_plans.find(e => e.value === filter.expense_plan).expenses,
                          )
                        : []
                    }
                    onChange={ev => {
                      setfilter({
                        ...filter,
                        init: false,
                        expense: ev.value,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-2">
              {permissions.commercial.reading && (
                <Col sm={4}>
                  <Form.Group>
                    <span className="lince-input_label">Turma</span>
                    <Slct
                      placeholder="..."
                      value={filter.commercial}
                      options={[{ label: "-- Todas --", value: "" }].concat(commercials)}
                      onChange={ev => {
                        setfilter({
                          ...filter,
                          init: false,
                          commercial: ev.value,
                        });
                      }}
                    />
                  </Form.Group>
                </Col>
              )}
              {permissions.suppliers.reading && (
                <Col sm={4}>
                  <Form.Group>
                    <span className="lince-input_label">Fornecedor</span>
                    <Slct
                      placeholder="..."
                      value={filter.provider}
                      options={[{ label: "-- Todos --", value: "" }].concat(providers)}
                      // options={providers}
                      onChange={ev => {
                        setfilter({
                          ...filter,
                          init: false,
                          provider: ev.value,
                        });
                      }}
                    />
                  </Form.Group>
                </Col>
              )}
            </Row>
            <Row className="mt-3">
              <Col sm={12}>
                <button
                  onClick={() => {
                    setfilter(filter_start);
                    setfilterTab("vencimentohoje");
                    setfilterInputs();
                    setReload(!reload);
                  }}
                  className={`clear-search ${
                    JSON.stringify(filter) === JSON.stringify(filter_start) ? "disabled" : ""
                  }`}
                >
                  <span>
                    <span>
                      <IcX />
                    </span>
                    <span>Limpar busca</span>
                  </span>
                </button>
              </Col>
            </Row>
            <div className="mt-4">
              <TabNotification
                style={{ fontSize: ".8em" }}
                options={[
                  { id: "vencimentohoje", label: "Vencimento Hoje", value: null, show: true },
                  { id: "todos", label: "Todos", value: null, show: true },
                  { id: "avencer", label: "A Vencer", value: null, show: true },
                  { id: "atrasados", label: "Atrasados", value: null, show: true },
                  { id: "pagos", label: "Pagos", value: null, show: true },
                  { id: "cancelados", label: "Cancelados", value: null, show: true },
                ]}
                setActive={ev => {
                  setfilterTab(ev);
                  if (ev === "todos") {
                    let _filter = {
                      ...filter,
                      date_start: null,
                      date_end: null,
                      due_date: null,
                      paid: null,
                      init: false,
                    };
                    delete _filter.paid;
                    setfilter(_filter);
                  } else if (ev === "pagos") {
                    setfilter({
                      ...filter,
                      date_start: null,
                      date_end: null,
                      due_date: null,
                      paid: 1,
                      init: false,
                    });
                  } else if (ev === "avencer") {
                    setfilter({
                      ...filter,
                      date_start: new Date(),
                      date_end: null,
                      due_date: null,
                      paid: 0,
                      init: false,
                    });
                  } else if (ev === "atrasados") {
                    setfilter({
                      ...filter,
                      date_start: null,
                      date_end: new Date(),
                      due_date: null,
                      paid: 0,
                      init: false,
                    });
                  } else if (ev === "vencimentohoje") {
                    setfilter({
                      ...filter,
                      due_date: new Date(),
                      paid: 0,
                      init: false,
                    });
                  } else if (ev === "cancelados") {
                    setfilter({
                      ...filter,
                      due_date: null,
                      paid: -1,
                      init: false,
                    });
                  }
                }}
                active={filterTab}
                init={"vencimentohoje"}
              />
            </div>
            <TableResponsive
              table={{
                head: [
                  { data: "Código" },
                  { data: "Conta" },
                  { data: "Vencimento" },
                  { data: "Valor" },
                  { data: "Método" },
                  { data: "Fornecedor/Turma" },
                  { data: "Informações" },
                  { data: "Status" },
                  ...(permissions.financialCompany.update ? [{ data: "Ações" }] : []),
                ],
                body:
                  bills?.map(__payment => {
                    let _cost_center = costCenter && costCenter.find(e2 => e2.value === __payment.cost_center_id);
                    let _expense_plan =
                      _cost_center && _cost_center.expense_plans.find(e2 => e2.value === __payment.expense_plan_id);
                    let _expense =
                      _expense_plan && _expense_plan.expenses.find(e2 => e2.value === __payment.expense_id);

                    let _provider = providers.length > 0 && providers.find(e2 => e2.value === __payment.provider_id);
                    let _commercial = __payment.commercials;

                    return {
                      disabled: __payment.paid === -1,
                      data: [
                        {
                          element: <span>{__payment.id}</span>,
                        },
                        {
                          element: <span>{_expense && _expense.label}</span>,
                        },
                        {
                          element: <span>{formatDate(__payment.due_date, 7)}</span>,
                        },
                        {
                          element: <span>{formatReal(__payment.value)}</span>,
                        },
                        {
                          element: (
                            <span>
                              {__payment.method_payment === "boleto"
                                ? "Boleto"
                                : __payment.method_payment === "pix"
                                  ? "PIX"
                                  : __payment.method_payment === "especie"
                                    ? "Espécie"
                                    : "Outro"}
                            </span>
                          ),
                        },
                        {
                          element: (
                            <span>
                              {_provider
                                ? _provider.label
                                : `${__payment.commercials?.course?.title} ${__payment.commercials?.year}.${__payment.commercials?.period} (${__payment.commercials?.institution?.title})`}
                            </span>
                          ),
                        },
                        {
                          element: (
                            <span>
                              <div>
                                <button className={`${tableStyle.seeTable}`}>Ver</button>
                              </div>
                            </span>
                          ),
                          id: "logs",
                          spoiler: (
                            <>
                              <div>
                                <p>
                                  <b>Centro de Custo:</b> {_cost_center && _cost_center.label}
                                </p>
                                <p>
                                  <b>Plano de Conta:</b> {_expense_plan && _expense_plan.label}
                                </p>
                                <p>
                                  <b>Conta:</b> {_expense && _expense.label}
                                </p>
                              </div>
                              {!!__payment.description && (
                                <>
                                  <div className="divisor mt-2 mb-2"></div>
                                  <div>
                                    <b>Descrição:</b> {__payment.description}
                                  </div>
                                </>
                              )}
                              <div className="divisor mt-2 mb-2"></div>
                              <div>
                                <p>
                                  Pagamento registrado por <b>{__payment.users.username}</b>
                                </p>
                                <p className="small-label">{formatDate(__payment.created_at, 4)}</p>
                              </div>
                              {!!__payment.userPaid && (
                                <div className="mt-2">
                                  <p>
                                    Pagamento confirmado por <b>{__payment.userPaid.username}</b>
                                  </p>
                                  <p className="small-label">{formatDate(__payment.updated_at, 4)}</p>
                                </div>
                              )}
                            </>
                          ),
                        },
                        {
                          element: (
                            <span>
                              {__payment.paid === 0 ? (
                                <StatusFlag status="Aguardando Pagamento" />
                              ) : __payment.paid === 1 ? (
                                <StatusFlag status="Pago" />
                              ) : (
                                <StatusFlag status="Cancelado" />
                              )}
                            </span>
                          ),
                        },
                        ...(!!permissions.financialCompany.update
                          ? [
                              {
                                element: (
                                  <span>
                                    {__payment?.paid === 0 ? (
                                      <>
                                        {!(__payment.status === "Cancelado" || __payment.status === "Pago") && (
                                          <div className="text-right">
                                            <Dropdown2
                                              toggle={<span>...</span>}
                                              menu={[
                                                {
                                                  label: "Confirmar Pagamento",
                                                  action: () => {
                                                    setpaymentConfirm(__payment?.id);
                                                  },
                                                },
                                                {
                                                  label: "Cancelar Pagamento",
                                                  action: () => {
                                                    setcancelPaymentModal(__payment?.id);
                                                  },
                                                },
                                                {
                                                  label: "Editar Pagamento",
                                                  action: () => {
                                                    seteditPayment(__payment);
                                                  },
                                                },
                                              ]}
                                            />
                                          </div>
                                        )}
                                      </>
                                    ) : __payment?.paid === 1 ? (
                                      <div className="text-right">
                                        <Dropdown2
                                          toggle={<span>...</span>}
                                          menu={[
                                            ...(!!__payment?.file_id
                                              ? [
                                                  {
                                                    label: "Download do Comprovante",
                                                    action: () => {
                                                      window.open(__payment.fileUrl);
                                                    },
                                                  },
                                                ]
                                              : []),
                                            {
                                              label: "Atualizar Comprovante",
                                              action: () => {
                                                setpaymentConfirm(__payment.id);
                                              },
                                            },
                                          ]}
                                        />
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                  </span>
                                ),
                              },
                            ]
                          : []),
                      ],
                    };
                  }) || [],
              }}
            />
            <Row>
              <Col>
                <Pagenation current={page.current} total={page.total} pageChange={pageChange} className="mt-3" />
              </Col>
            </Row>
          </Content>
        ) : (
          <Content>
            <Loading />
          </Content>
        )}
      </Main>
    </>
  );
}
